export default __webpack_public_path__ + "static/media/top-bc.d6409adb.webp";